export const invitations = {
  cta: {
    share: {
      data: {
        text: 'Hi! Have you heard of Creative Shelter? I invoice my copyright through them and keep more money in my pocket. Want to give it a try? Invoice for free for 60 days. (So you keep even more!)',
        title: 'Creative Shelter’s invoicing platform',
      },
      permissionDenied: 'You need to give permission to share your invitation link.',
    },
    socials: {
      twitter: {
        hashtags: '#copyright #earnmore #creativeshelter',
        text: 'Hey you! Have you heard of Creative Shelter? I invoice my copyright through them and keep more money in my pocket. Want to give it a try? Invoice for free for 60 days!',
      },
    },
  },
  discount: {
    ariaLabel: 'Discount progress: {{completed}} of {{total}} steps completed',
  },
  discountProgress: {
    currentDiscount: 'You’re currently getting a {{percentage}}% discount',
    hint_one: 'Invite {{count}} more friend',
    hint_other: 'Invite more {{count}} friends',
    savedLabel: 'You’ve already saved',
    step: '{{percentage}}% discount on your fee',
  },
  hero: {
    buttons: {
      copyLink: 'Copy link',
      copyLinkSuccess: 'Copied!',
      email: 'Send an email',
      share: 'Share',
    },
    description:
      'Share your personal link. As soon as your friend/colleague sends their first invoice, you get a 25% discount on your fee to Creative Shelter and your friend invoices for free for 60 days.',
    shareVia: 'or share via',
    socials: {
      facebook: 'Share via Facebook',
      linkedin: 'Share via LinkedIn',
      whatsapp: 'Share via WhatsApp',
      x: 'Share via X',
    },
    title: 'Invite a friend and get a discount',
  },
  howItWorks: {
    disclaimer:
      'The 25% discount is valid for one year and starts as soon as the person you invited has sent a first invoice, within 30 days of creating an account. For the person you invite, the discount starts immediately after creating their account.',
    steps: {
      earn: 'You earn a 25% discount for every friend who invoices',
      invoice: 'Your friend invoices for free for 60 days',
      register: 'Your friend registers with your personal link',
    },
    title: 'How does it work?',
  },
  sendInvitationDialog: {
    errors: {
      accountAlreadyExists: 'This freelancer already invoices through Creative Shelter. 🙌',
      noDoubleInvite: 'You’ve already sent an invitation to this email address.',
      noSelfInvite: 'You can’t invite yourself!',
      userAlreadyExists:
        'This freelancer already has an account with Creative Shelter, but isn’t invoicing yet. Sometimes people just need a little nudge.',
    },
    form: {
      inviteeEmailAddressField: {
        label: 'Email address',
      },
      inviteeFirstNameField: {
        label: 'First name',
      },
      inviteeLanguageField: {
        label: 'Language',
      },
      inviteeLastNameField: {
        label: 'Last name',
      },
      submitButton: 'Send',
    },
    success: 'Your invitation has been sent to {{ name }}.',
    title: 'Invite someone',
  },
  sentInvitations: {
    headers: {
      email: 'Email',
      name: 'Name',
      status: 'Status',
    },
    status: {
      accepted: 'Registered',
      declined: 'Declined',
      pending: 'Pending',
    },
    title: 'Sent invitations',
  },
  title: 'Invite friends',
};
